var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscipline3By3Icon = function SvgDiscipline3By3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 4,
    y: 4,
    fill: "currentColor",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 11,
    y: 4,
    fill: "currentColor",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 18,
    y: 4,
    fill: "currentColor",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 4,
    y: 11,
    fill: "currentColor",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 11,
    y: 11,
    fill: "currentColor",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 18,
    y: 11,
    fill: "currentColor",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 4,
    y: 18,
    fill: "currentColor",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 11,
    y: 18,
    fill: "currentColor",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 18,
    y: 18,
    fill: "currentColor",
    rx: 1
  })));
};
export default SvgDiscipline3By3Icon;